import { isEmpty } from 'lodash';
import { AppOwnerType, OwnerForm } from 'common-types';
import { isValidEmail } from '../../common/common-utils';

export const filterDupAppOwners = (appOwners: AppOwnerType[]) => {
  return appOwners.reduce((acc: AppOwnerType[], val: AppOwnerType) => {
    if (acc.some(o => o.email === val.email)) return acc;
    acc.push(val);
    return acc;
  }, []);
};

export const validateOwnersFormList = (ownersFormList: OwnerForm[]) => {
  const regex = new RegExp('[a-zA-Z][a-zA-Z]{2,}');

  return ownersFormList.map(o => {
    const { email, name } = o;
    let invalidEmailMsg = '',
      invalidNameMsg = '';
    if (isEmpty(email)) {
      invalidEmailMsg = 'Missing email';
    }
    if (isEmpty(name)) {
      invalidNameMsg = 'Missing owner name';
    }
    if (!isValidEmail(email)) {
      invalidEmailMsg = 'Invalid email';
    }
    if (!regex.test(name)) {
      invalidNameMsg = 'Invalid Name';
    }

    return invalidEmailMsg || invalidNameMsg
      ? {
          ...o,
          invalidEmailMsg,
          invalidNameMsg,
        }
      : {
          ...o,
          invalidEmailMsg: '',
          invalidNameMsg: '',
        };
  });
};
